import { useNavigate, useRouteError, isRouteErrorResponse } from 'react-router-dom'
import { useLanguage } from '@/hooks/useLanguage'
import { t } from '@/utils/i18n'
import EmptyState from '@/components/common/EmptyState/EmptyState'
import Button from '@/components/common/Button/Button'
import { IconWarning } from '@/components/icons/Icons'
import './ErrorPage.css'

function ErrorPage() {
  const navigate = useNavigate()
  const { language } = useLanguage()
  const error = useRouteError()

  let errorTitle = t('error.generic', language) || '오류가 발생했습니다'
  let errorDescription = t('error.genericDesc', language) || '예상치 못한 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      errorTitle = t('error.notFound', language) || '페이지를 찾을 수 없습니다'
      errorDescription = t('error.notFoundDesc', language) || '요청하신 페이지가 존재하지 않거나 이동되었습니다.'
    } else if (error.status === 500) {
      errorTitle = t('error.serverError', language) || '서버 오류'
      errorDescription = t('error.serverErrorDesc', language) || '서버에서 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'
    } else {
      errorTitle = `${t('error.error', language) || '오류'} ${error.status}`
      errorDescription = error.statusText || errorDescription
    }
  } else if (error instanceof Error) {
    if (error.message.includes('Network') || error.message.includes('Failed to fetch')) {
      errorTitle = t('error.networkError', language) || '네트워크 오류'
      errorDescription = t('error.networkErrorDesc', language) || '인터넷 연결을 확인하고 다시 시도해주세요.'
    } else {
      errorDescription = error.message
    }
  }

  return (
    <div className="error-page">
      <div className="error-page__content">
        <EmptyState
          icon={<IconWarning size={32} />}
          title={errorTitle}
          description={errorDescription}
        />
        <div className="error-page__actions">
          <Button
            variant="primary"
            onClick={() => navigate('/dreams')}
          >
            {t('error.goHome', language) || '홈으로 이동'}
          </Button>
          <Button
            variant="ghost"
            onClick={() => window.location.reload()}
          >
            {t('common.refresh', language)}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage

